export default __webpack_public_path__ + "static/media/Company2.4ec5f8af.png";